import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { StickyNav } from './components/StickyNav';
import { SiteFooter } from './components/SiteFooter';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { WhoItsForPage } from './pages/WhoItsForPage';
import { About } from './pages/About';
import { BookPage } from './pages/BookPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2mmcc83go129n">
      <ScrollToTop data-id="element-1" data-mp="2mmvob3jmwwfr" />
      <div className="flex min-h-screen w-full flex-col bg-ink-900 font-sans text-white" data-id="element-2" data-mp="2mnnh66lukg2c">
        <StickyNav data-id="element-3" data-mp="31c9vq63nh3si" />
        <main className="flex-1" data-id="element-4" data-mp="31ctflscv2296">
          <Routes data-id="element-5" data-mp="2wjgqzi86lvgf">
            <Route path="/" element={<Home data-id="element-7" data-mp="2wifhhi6tdh0t" />} data-id="element-6" data-mp="2wiyx2s8zrtbo" />
            <Route path="/how-it-works" element={<HowItWorksPage data-id="element-9" data-mp="28tw972nrl48q" />} data-id="element-8" data-mp="2wi5nzkmk8rqd" />
            <Route path="/who-its-for" element={<WhoItsForPage data-id="element-11" data-mp="23vciyq2516ak" />} data-id="element-10" data-mp="28suw6sn6u7od" />
            <Route path="/about" element={<About data-id="element-13" data-mp="23utas12ahw9q" />} data-id="element-12" data-mp="23w4e5zrtp20b" />
            <Route path="/book" element={<BookPage data-id="element-15" data-mp="3ik7jmqgv0tve" />} data-id="element-14" data-mp="23ti8y6semyl9" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-17" data-mp="3ijpc2xoqyt86" />} data-id="element-16" data-mp="3iiwaeb4natww" />
          </Routes>
        </main>
        <SiteFooter data-id="element-18" data-mp="3mkhofzsx1e8o" />
      </div>
    </BrowserRouter>;
}